export const floatRegx = /^-?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)$/;

export const decimalRegx = /^\d*(\.\d{0,2})?$/;

export const decimalRegx_3dit = /^\d+(\.\d{0,3})?$/;

export const onlyNumberRegx = /^\d+$/;

export const passwordRgx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/;

export const onlyTextRegx = /^[a-zA-Z]+$/;

export const charRegx = /^[\s.]*([^\s.][\s.]*){0,100}$/;

export const zeroTo100AllowWithDecimal_Regx = /^(\d{1,2}(\.\d{1,2})?|100(\.0{1,2})?)$/;









